import { render, staticRenderFns } from "./ModifyResponsibleForm.vue?vue&type=template&id=3b1686be&scoped=true"
import script from "./ModifyResponsibleForm.vue?vue&type=script&lang=js"
export * from "./ModifyResponsibleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1686be",
  null
  
)

export default component.exports